import React, { useEffect, useState } from 'react';
import { getGCSUrl } from '../../../../services/Common';
import TuringCollapse from './TuringCollapse';
import PropTypes from 'prop-types';
import { Row, Button, message } from 'antd';

function RequiredActionCollapse ({ service }) {
  const requiredActions = (service && service.state.requiredActions) || [];
  const sugg = (service && service.state.sugg[service.state.activeForm]) || [];
  const unmappedResumeData = (service && service.state.unmappedResumeData) || [];
  const vetsmithFlowData = (service && service.state.vetsmithFlowData) || null;
  let customProfileQuestions = [];
  if (vetsmithFlowData && vetsmithFlowData.custom_profile_questions) {
    customProfileQuestions = JSON.parse(vetsmithFlowData.custom_profile_questions.step_custom_questions);
    if (customProfileQuestions && Array.isArray(customProfileQuestions)) {
      customProfileQuestions.map((question) => {
        question.content = question.text;
        return question;
      })
    }
  }


  const onUploadedResumeView = () => {
    const { PersonalInformation } = service.state;
    const resume = PersonalInformation.resume || '';
    if (resume) {
      window.open(`${getGCSUrl()}/resume/${resume}`, '__blank');
    } else {
      message.info('No uploaded resume found');
    }
  };

  const [showParsedInfo, setShowParsedInfo] = useState(false);
  useEffect(() => {
    const onResize = () => {
      const parentElm = document.querySelector('.FinalizeResumeV2RequiredActionsparent');
      const elm = document.querySelector('.FinalizeResumeV2RequiredActions');
      if (parentElm && elm && parentElm.offsetWidth) {
        elm.style.width = parentElm.offsetWidth + 'px';
      }
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [requiredActions, sugg]);
  const requiredActionsList = requiredActions.filter(item => item.group !== 'skillsMismatchInYOE');
  const suggActionsList = requiredActions.filter(item => item.group === 'skillsMismatchInYOE');

  function toggleParsedInfoSection (isActive) {
    setShowParsedInfo(!!isActive);
  }

  return (
    <div className="FinalizeResumeV2RequiredActionsparent">
      <div className="FinalizeResumeV2RequiredActions">
        {requiredActionsList.length ? (
          <TuringCollapse active title="Required actions" hideEditInfo className={`color1 requiredActionsListnoicon ${showParsedInfo ? 'hide' : ''}`}>
            {requiredActionsList.map((item, i) => <RequiredActionItem key={i + '-' + item.title} item={item} icon={null} />)}
          </TuringCollapse>
        ) : null}
        {/* {!unmappedResumeData.length ? null
          : <TuringCollapse active={showParsedInfo} onCollapseChange={toggleParsedInfoSection} title="Info parsed from your resume" hideEditInfo className="parsedInfo color4 requiredActionsListnoicon resume-text" >
            <Row type="flex" justify="center">
              <Button onClick={onUploadedResumeView} className='view-uploaded-resume-btn'><span className="material-icons" style={{ color: '#2E6EDF', fontSize: '18.33px', marginRight: 10 }}>visibility</span>View Uploaded Resume</Button>
            </Row>
            { unmappedResumeData.map((item, i) => <RequiredActionItem key={i} item={item} type="parsed-data" icon={null}/>)}
          </TuringCollapse>
        } */}
        {(suggActionsList.length && (!service.state.activeForm || service.state.activeForm === 'WorkHistory')) ? (
          <TuringCollapse active title="Suggested actions" hideEditInfo className="color3">
            {suggActionsList.map((item, i) => <RequiredActionItem key={i + '-' + item.title} item={item} icon="lightbulb" />)}
          </TuringCollapse>
        ) : null}
        {sugg.length ? (
          <TuringCollapse active title="Suggestion for this section" hideEditInfo className="color2">
            {sugg.map((item, i) => <RequiredActionItem key={i + '-' + item.title} item={item} icon="assistant" />)}
          </TuringCollapse>
        ) : null}
        {customProfileQuestions.length ? 
          <TuringCollapse active title="Changes required for profile update" hideEditInfo className="profile-udpdate color5">
            {customProfileQuestions.map((item, i) => <RequiredActionItem key={i + '-' + item.text} item={item} icon="info" />)}
          </TuringCollapse>
        : null}
      </div>
    </div>
  );
}

RequiredActionCollapse.propTypes = {
  service: PropTypes.any
};

const seeMore = (text) => {
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text.slice(0, 200) + (text.length < 201 ? '' : '...') : text}
      <span onClick={toggleReadMore} className="see-more-0r-less">
        {text.length < 201 ? null : isReadMore ? ' See more' : ' See less'}
      </span>
    </p>
  );
};

function RequiredActionItem ({ children, item, icon = 'report_problem', type }) {
  const [state, setState] = useState('');

  if (!item) return null;
  return (
    <div className={`RequiredActionItem RequiredActionItem-${icon || 'noicon'}`}>
      {icon ? <span className="material-icons" aria-hidden="true">{icon}</span> : null}
      <div className="RequiredActionItem-content">
        <div className={`RequiredActionItem-show  ${state === 'edit' ? 'RequiredActionItem-close' : 'RequiredActionItem-open'}`}>
          <div className="RequiredActionItemflex1">
            {item.title ? <div className={type === 'parsed-data' ? 'parsedInfo-text' : 'RequiredActionItem-title'}>{ type === 'parsed-data' ? seeMore(item.title.toLowerCase()) : item.title }</div> : null}
            {children || item.content}
          </div>
          {item.editContent ? (
            <div className="RequiredActionItem-btn" onClick={e => setState('edit')}>
              <span className="material-icons" aria-hidden="true">edit</span>
            </div>
          ) : null}
        </div>
        {item.editContent ? (
          <div className={`RequiredActionItem-edit ${state === 'edit' ? 'RequiredActionItem-open' : 'RequiredActionItem-close'}`}>
            <div className="RequiredActionItemflex1">
              {item.editContent}
            </div>
            <div className="RequiredActionItem-btn" onClick={e => setState('')}>
              <span className="material-icons" aria-hidden="true">cancel</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

RequiredActionItem.propTypes = {
  children: PropTypes.any,
  item: PropTypes.any,
  icon: PropTypes.any,
  type: PropTypes.string
};

export default RequiredActionCollapse;
